import { Module } from "@nestjs/common";
import { ApplicationExceptionHandler } from "@project-management-system/backend-utils";
import { TypeOrmModule } from "@nestjs/typeorm";
import { LocationsEntity } from "./locations.entity";
import { LocationsController } from "./locations.controller";
import { LocationsService } from "./locations.service";
import { LocationsAdapter } from "./locations.adapter";



@Module({
    imports: [
        TypeOrmModule.forFeature([LocationsEntity]),
    ],
    controllers: [LocationsController],
    providers: [LocationsService, ApplicationExceptionHandler,LocationsAdapter]
})
export class LocationsModule {

}